'use strict';

const $ = require('jquery');
const Event = require('./../lib/events');
const Breakpoint = require('./../lib/breakpoints');

class FloatingLink {

    constructor() {

        Event.on('load resize', window, () => {

            if (Breakpoint.atLeast('medium')) {

                this.setsFloatingLink();
            }
        });
    }

    setsFloatingLink() {

        let $floatingLink = $('.floating-link');
        let $floatingLinkWrapper = $('.floating-link-wrapper');
        let $headerHeight = $('#header').height();

        if ($floatingLink.length > 0) {

            $floatingLinkWrapper.height($floatingLink.outerHeight());

            App.Globals.$window.on('load scroll', function () {

                let windowTop = App.Globals.$window.scrollTop();

                if ((windowTop + $headerHeight) >= $floatingLinkWrapper.offset().top) {

                    App.Globals.$body.addClass('scrolled');
                } else {

                    App.Globals.$body.removeClass('scrolled');
                }
            });
        }
    }
}

module.exports = FloatingLink;
